import React from 'react'
import { useFilters } from '../../Common/Hooks/useFilters'
import { DateRangeFilterSummary } from './DateRangeFilterSummary'
import { Filter } from './Filtering'
import './Filters.css'

export interface FiltersProps {
	filters: Filter[]
}

export function Filters(props: FiltersProps): JSX.Element {

	const { removeFilterValue, rotateFilterKey } = useFilters()

	const dateRangeFilter = props.filters.find(f => f.key === 'dateRange')

	return (
		<div className='filters'>
			{filterSummary('Players', props.filters.find(f => f.key === 'players'))}
			{filterSummary('Players as Spirits', props.filters.find(f => f.key === 'playersAsSpirits'))}
			{filterSummary('Adversaries', props.filters.find(f => f.key === 'adversaries'))}
			{filterSummary('Blight cards', props.filters.find(f => f.key === 'blightCards'))}
			{dateRangeFilter && <DateRangeFilterSummary filter={dateRangeFilter} />}
			{filterSummary('Difficulties', props.filters.find(f => f.key === 'difficulties'))}
			{filterSummary('Island state', props.filters.find(f => f.key === 'islandStates'))}
			{filterSummary('Layouts', props.filters.find(f => f.key === 'layouts'))}
			{filterSummary('Locations', props.filters.find(f => f.key === 'locations'))}
			{filterSummary('Number of spirits', props.filters.find(f => f.key === 'spiritCounts'))}
			{filterSummary('Outcome', props.filters.find(f => f.key === 'outcomes'))}
			{filterSummary('Outcome type', props.filters.find(f => f.key === 'outcomeTypes'))}
			{filterSummary('Spirits', props.filters.find(f => f.key === 'spirits'))}
			{filterSummary('Aspects', props.filters.find(f => f.key === 'aspects'))}
			{filterSummary('Turns', props.filters.find(f => f.key === 'turns'))}
		</div>
	)

	function filterSummary(title: string, filter: Filter | undefined): JSX.Element | null {
		if (filter === undefined) {
			return null
		}

		let typeText: string | null = null
		if (filter.canChangeType) {
			switch (filter.type) {
				case 'all':
					typeText = `All of:`
					break

				case 'any':
					typeText = `Any of:`
					break

				case 'exact':
					typeText = `Exactly these:`
					break
			}
		}

		return (
			<div className='filter'>
				<span className='filter-title'>{title}:</span>

				{
					typeText !== null &&
					<span className='filter-type'>
						<button className='link-button' onClick={() => { rotateFilterKey(filter.key) }}>
							<span className='rotate-type'>&#x21bb;</span>
							{typeText}
						</button>
					</span>
				}

				{
					filter.values.map((value, i) =>
						<span className='filter-item' key={i}>
							<button className='link-button remove' onClick={() => { removeFilterValue(filter.key, value) }}>&times;</button>
							{value}
						</span>
					)
				}
			</div>
		)
	}
}
